<template>
  <v-app id="inspire">
  <Header type="search" @stopInterval="stopInterval($event)" @startInterval="startInterval($event)" />
  <v-main class="grey lighten-3">
    <v-container>
      <v-row>

        <Menu/>

        <v-container class="col-10">
          <v-row>
            <v-col
                class="page-top d-flex justify-space-between"
                cols="12"
            >
              <div>
                <div class="page-title">Ресепшен</div>
                <div class="breadcrumb">Ресепшен</div>
              </div>
            </v-col>
            <v-col>
              <v-skeleton-loader
                  v-if="isLoading"
                  type="text"
              >
              </v-skeleton-loader>
              <div class="page-subtitle" v-else>
                Посетители в клубе: {{ listVisitor.listLength }} человек
              </div>
              <v-sheet
                  rounded="lg"
                  class="mt-5"
              >
                <v-card-title>
                  <v-text-field
                      v-model="search"
                      rounded
                      outlined
                      dense
                      required
                      label="Поиск посетителей"
                      style="font-size: 12px;font-weight: normal"
                      background-color="white"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>mdi-magnify</v-icon>
                    </template>
                  </v-text-field>
                  <v-btn-toggle
                      v-model="toggle_exclusive"
                      mandatory
                      class="ml-5 rounded-lg"
                      style="margin-top: -27px;"
                  >
                    <v-btn @click="now">
                      Сейчас
                    </v-btn>
                    <v-btn @click="today">
                      Сегодня
                    </v-btn>
                    <v-btn @click="toDate">
                      На дату
                    </v-btn>
                  </v-btn-toggle>

                  <div style="margin-top: -27px; flex: none !important; margin-right: 460px" >
                    <VueDatePicker
                        no-title
                        no-header
                        color="#629f34"
                        class="ml-5"
                        range
                        rangeInputText="%d - %d"
                        format="DD MMMM"
                        v-model="date"
                        v-show="dialogDate"
                        style="margin-right: -360px;"
                    >
                      <template #activator="{ date }">
                        <button
                            class="button custom__button"
                            ref="activator"
                            type="button"
                        >
                          <v-icon
                              dark
                              right
                              small
                              class="mr-2"
                          >
                            mdi-calendar-blank-outline
                          </v-icon>  {{ date }}
                        </button>
                      </template>
                    </VueDatePicker>
                  </div>
                </v-card-title>
                <v-skeleton-loader
                  v-if="isLoading"
                  type="table"
                >
                </v-skeleton-loader>
                <v-data-table
                    v-else
                    v-model="selected"
                    no-data-text="Не найдено посетителей по этой дате"
                    :headers="headers"
                    :items="searchClients"
                    :hide-default-footer="true"
                    :page="page"
                    item-key="client_id"
                    show-select
                    class="elevation-1 custom__table"
                >
                  <template v-slot:header.data-table-select="{ on, props }">
                    <v-tooltip
                        top
                        content-class="black tooltip-top"
                    >
                      Выбрать всех
                      <template v-slot:activator="{ on: onTooltip }">
                        <v-simple-checkbox
                            v-ripple
                            color="#629F33"
                            v-bind="props"
                            v-on="{ ...on, ...onTooltip }"
                        ></v-simple-checkbox>
                      </template>
                    </v-tooltip>
                  </template>

                  <template v-slot:item.client_fio="{ item }">

                    <div style="">

                      <span @mouseover="item.show_photo = true" @mouseleave="item.show_photo = false" style="cursor:pointer;">{{ item.client_fio }}</span>

                      <div v-if="item.show_photo" class="user-avatar" style="position:absolute; width:300px; height:300px; z-index: 900; top:350px; left:5%;">
                        <img
                            :src="item.photo ? item.photo : '/playground_assets/mediumcamera3282-238l.svg'"
                            :style="item.photo ? 'height: 300px; width: 300px; border-radius: 145px;' : 'height: 37px; width: 46px'"
                        />
                      </div>

                    </div>

                  </template>
                  
                  <template v-slot:item.data-table-select="{ isSelected, select }">
                    <v-simple-checkbox style="width: 26px !important;" color="#629F33" :value="isSelected" @input="select($event)"></v-simple-checkbox>
                  </template>
                  <template v-slot:item.client_debt="{ item }">
                    <span style="color:#D53025;">
                      {{ item.client_debt }} ₽
                    </span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-menu
                        bottom
                        left
                        offset-y
                        rounded="lg"
                        content-class="custom__menu"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            class="dots-button__actions"
                        >
                          <v-icon size="20px">mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>

                      <v-list>
                        <v-list-item
                            v-if="item.date_exit ==='00:00'"
                            @click="exitButton(item.client_id)"
                        >
                          <v-list-item-title>Выпустить клиента</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            :to="{
                              name: 'Desktop',
                              params: {client_id: item.client_id}
                            }"
                        >
                          <v-list-item-title>Оплатить долг</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            :to="{
                              name: 'Desktop',
                              params: {client_id: item.client_id}
                            }"
                        >
                          <v-list-item-title>Рабочий стол</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-data-table>
                <v-card-actions
                    class="d-flex justify-content-between"
                    style="padding: 20px !important;"
                    v-if="listVisitor"
                >
                  <v-btn
                      v-if="selected.length !== 0"
                      class="exit-button"
                      style="padding: 7px 20px !important;"
                      @click="exitClients(selected)"
                  >
                    <v-icon
                        dark
                        small
                        class="mr-1"
                    >
                      mdi-exit-to-app
                    </v-icon>
                    Выпустить
                  </v-btn>
                  <div v-else></div>
                  <div>
                    <v-pagination
                        v-model="page"
                        circle
                        color="#629F33"
                        :length="listVisitor.paginationLength"
                        :total-visible="6"
                    ></v-pagination>
                  </div>
                </v-card-actions>
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>
      </v-row>
    </v-container>
  </v-main>
  </v-app>
</template>

<script>
import {mapState} from "vuex";
import { VueDatePicker } from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {receptionActionTypes} from '@/store/modules/reception';
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {clientActionTypes} from '@/store/modules/client';
import {getItem, setItem} from "../helpers/persistanceStorage";
export default {
  name: 'Main',
  components: {
    VueDatePicker,
    Header,
    Menu,
  },
  data() {
    return {
      cardRightNow:false,
      dialogClient: false,
      dialog: false,
      selected: [],
      page: 1,
      counterInterval:null,
      dialogDate: false,
      toggle_exclusive: 0,
      date: new Date(),
      search: '',
      headers: [
        {
          text: 'Клиент',
          align: 'start',
          sortable: false,
          value: 'client_fio',
        },
        { text: 'Вход', value: 'date_entrance', sortable: true },
        { text: 'Выход', value: 'date_exit', sortable: true },
        { text: 'В клубе', value: 'club_time', sortable: true },
        { text: 'Долг', value: 'client_debt', sortable: true },
        { text: 'Основание', value: 'client_base', sortable: true },
        {text: 'Действие', value: 'actions', sortable: false},
      ],
      clients: []
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.reception.isLoading,
      listVisitor: state => state.reception.listVisitor,
      validationErrors: state => state.reception.validationErrors,
      userType: state => state.userType, //Роль пользователя
    }),
    searchClients() {
      return this.listVisitor.visitor.filter((i) => {
        return !this.search || (i.client_fio.toLowerCase().includes(this.search.toLowerCase()));
      })
    }
  },
  methods: {
    startInterval(){
      this.counterInterval =  setInterval(this.sendRequest, 1000);
    },
    stopInterval(){
      clearInterval(this.counterInterval)
    },
    fetchFeed() {
      this.$store.dispatch(receptionActionTypes.getVisitorList)
    },
    fetchFeedCard(card_id) {
      this.$store.dispatch(receptionActionTypes.desktopClientCard, {card_id}).then((res) => {
        if (res && res.success && res.client && res.client.client_id) {
          this.$router.push({name: 'Desktop', params: {client_id: res.client.client_id, card_scan_id:card_id}})
        } else {
          this.stopInterval();
          alert("Клиент не найден!");
        }
      }).catch(error => {
        //alert(error.msg)
        console.log('error')
        //this.counterInterval = setInterval(this.sendRequest, 1000);
      });
    },
    now() {
      this.$store.dispatch(receptionActionTypes.getVisitorList)
      this.dialogDate = false;
    },
    today() {
      let data_time = new Date();
      let data = {}
      data.date_start = data_time
      data.date_end = data_time
      this.$store.dispatch(receptionActionTypes.getVisitorList, {data})
      this.dialogDate = false;
    },
    toDate() {
      let data = this.date;
      this.$store.dispatch(receptionActionTypes.getVisitorList, {data})
      this.dialogDate = true;
    },
    exitButton(id) {
      this.$store.dispatch(clientActionTypes.changeClientStatus, {
        client_id: id,
        type: 'exit'
      })
          .then(() => {
            this.fetchFeed()
          })
    },
    exitClients(items) {
      for (let client of items) {
        this.$store.dispatch(clientActionTypes.changeClientStatus, {
          client_id: client.client_id,
          type: 'exit'
        })
            .then(() => {
              this.fetchFeed()
            })
      }
      this.selected.length = 0;
    },
    sendRequest() {
      this.cardRightNow = false;
      var xmlhttp = new XMLHttpRequest();
      let vm = this

      xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
          console.log('RESSS'+xmlhttp.responseText)
         // let responseT = responseTest
          //let responseTest = '3FB5DF5B ';
          if (xmlhttp.status == 200) {
            clearInterval(vm.counterInterval)
              if(xmlhttp.responseText.length>0)
              {
                if(!vm.cardRightNow)
                {
                  var transformArray = xmlhttp.responseText.split(/(..)/g).filter(s => s);
                  transformArray.reverse();
                  var resultString = transformArray.length === 7 ? transformArray.join('') : transformArray.join('')+'000000';
                  console.log(resultString);
                  console.log('Card has been placed on reader: '+resultString); // action here!!!!

                  //vm.$router.push({ name: 'Desktop', params: { client_id: resultString } })
                  vm.fetchFeedCard(resultString);
                  vm.cardRightNow = true;
                }
              }
              else
              {
                vm.counterInterval = setInterval(vm.sendRequest, 1000);
                if(vm.cardRightNow)
                {
                  cardRightNow = false;
                  console.log('no card');
                  console.log('Card has been removed from reader: '); //card removed (may be needed in future)
                }
              }
            }
          else if (xmlhttp.status == 400) {
            console.log('There was an error 400');
					   }
					else {
            console.log('something else other than 200 was returned');
					}

        }
      };

      xmlhttp.open("GET", "http://localhost:8081/scard", true);
      xmlhttp.send();
    }
  },
  mounted() {
    setItem('schedule-service', null)
    setItem('schedule-client_id', null)
    setItem('schedule-client_name', null)
    setItem('schedule-search_client', null)
    setItem('schedule-select_client', null)
    setItem('sales-monitor-specialist_id', null);
    setItem('sales-monitor-specialist_type', null);
    setItem('sales-monitor-datetype', null);
    setItem('sales-monitor-datetype_date', null);

    setItem('report_12',null);
    setItem('report_13',null);
    setItem('report_14',null);
    setItem('report_15',null);
    setItem('report_16',null);
    setItem('report_17',null);
    
    setItem('report_newclient_id',null);
    
    this.fetchFeed();
  },
  created: function(){
    if(!this.counterInterval){
      this.counterInterval =  setInterval(this.sendRequest, 1000);
    }
  },
  destroyed: function(){
    clearInterval(this.counterInterval)
  },
  watch: {
    dialogClient() {
      if (this.dialogClient) {
        this.stopInterval()
      }
    },
    date() {
      let data = {}
      if(this.date.start){
        data = {}
        data.date_start = this.date.start
        data.date_end = this.date.end
      } else {
        data.date_start = this.date
        data.date_end = this.date
      }
      this.$store.dispatch(receptionActionTypes.getVisitorList, {data})
    },
    validationErrors() {
      alert('Клиент не найден!');
      this.counterInterval = setInterval(this.sendRequest, 1000);
      console.log(this.validationErrors);
    }
  }
}
</script>

<style scoped>
.v-data-table-header th{
  background-color: #F1F1F1!important;
  color: #1A1A1A!important;
  border-left: 1px solid #E0E0E0;
}

.custom__button {
  width: 180px;
  height: 20px;
  display: flex;
  padding: 7px 20px;
  max-width: 180px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  border-color: rgba(224, 236, 214, 1);
  border-style: solid;
  border-width: 4px;
  margin-right: 0;
  border-radius: 12px;
  margin-bottom: 0;
  justify-content: center;
  background-color: var(--dl-color-default-primarysuccess);
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  color: #fff!important;
}

.custom__menu {
  max-height: 112px !important;
  max-width: 199px !important;
}
.custom__menu > .v-list > .v-list-item {
  min-height: 32px !important;
}
.custom__menu > .v-list > .v-list-item > .v-list-item__title {
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
}

.dots-button__actions {
  width: 24px;
  height: 24px;
  background: #F1F1F1;
  border-radius: 25px;
}
.dots-button__actions[aria-expanded="true"] {
  background: #629F33;
  outline: 4px solid #E0ECD6;
}
.dots-button__actions[aria-expanded="true"] > .v-btn__content .v-icon {
  color: #fff;
}

.dots-button__actions:hover {
  background: #629F33;
}
.dots-button__actions:hover > .v-btn__content .v-icon {
  color: #fff;
}

.theme--light.v-btn.v-btn--has-bg {
  background-color: #fff;
  font-weight: bold;
  font-size: 11px;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
   height: 36px!important;
  color: #767676!important;
}

.theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
  opacity: 0!important;

}

#inspire > div > main > div > div > div > div:nth-child(3) > div > div.v-card__title > div.v-item-group.theme--light.v-btn-toggle.v-btn-toggle--rounded > button.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default{
  color:#629F33!important;
}

#inspire > div > main > div > div > div > div:nth-child(3) > div > div.v-card__title > div.v-input.v-input--hide-details.theme--light.v-text-field.v-text-field--single-line.v-text-field--is-booted{
  height: 35px!important;
}

.v-text-field > .v-input__control > .v-input__slot:before {
   border-color: white!important;
  border-bottom: none!important;
}

#inspire > div > main > div > div > div > div:nth-child(3) > div > div.v-card__title > div.v-input.v-input--hide-details.v-input--dense.theme--light.v-text-field.v-text-field--single-line.v-text-field--solo.v-text-field--solo-inverted.v-text-field--solo-flat.v-text-field--is-booted.v-text-field--enclosed.v-text-field--outlined.v-text-field--rounded > div > div{
  background:#fff!important;
}

.v-data-table__wrapper{
  border-radius: 0px!important;
}
.v-text-field--outlined >>> fieldset {
  border-color: #E0E0E0;
  font-size: 11px;
}
.v-card__subtitle, .v-card__text, .v-card__title {
  padding-bottom: 0 !important;
}
</style>